import React from "react";
import { cn } from "utils";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Member/Subscription/SubscriptionCard/PurchaseActions/index";

const I18n = I18nUtil.createScoped(Translations);

interface PayPalPayButtonProps {
  onClick: () => void;
  disabled?: boolean;
  /** 当前套餐 id，仅作埋点参数 */
  planId?: string;
}

/**
 * PayPal 次级支付入口（"or + PayPal" 文字链，复刻 crypto 二级入口模式）
 * 显隐由父组件 PurchaseActions 控制（payment_configs 含 ACTIVE PAYPAL 且非 App 内）
 */
const PayPalPayButton: React.FC<PayPalPayButtonProps> = ({
  onClick,
  disabled = false,
  planId,
}) => (
  <div
    data-or-view="paypal_button_view"
    data-or-param-planid={planId}
    className={cn(
      "flex flex-row items-center justify-center body_m text-content_tertiary",
      disabled && "text-content_tertiary/20",
    )}
  >
    <span>{I18n.t("or")}</span>
    {/* PayPal 品牌名不做翻译；logo 资产待设计提供后走 icon-svg-gen 流程替换文字。
        disabled 渲染为纯文本（非交互）：声明式 data-or-event 不受 onClick 拦截影响，
        置灰态必须物理上不挂事件属性，否则点击量虚高（review #38） */}
    {disabled ? (
      <div
        data-openreplay-label="member_purchaseactions_paypal"
        className="text-content_tertiary/20 button_m ml-1"
      >
        PayPal
      </div>
    ) : (
      <div
        data-openreplay-label="member_purchaseactions_paypal"
        data-or-event="paypal_button_click"
        data-or-param-planid={planId}
        onClick={() => {
          onClick();
        }}
        className="md:text-content_brand_primary text-content_accent4_primary hover:text-content_brand_primary/70 cursor-pointer button_m ml-1"
      >
        PayPal
      </div>
    )}
  </div>
);

export default PayPalPayButton;
